<div
  class="file-uploader"
  [class.file-uploader--hover]="isHovering"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event)"
  (drop)="onDrop($event)"
>
  <input #fileInput type="file" class="sr-only" (change)="onFileSelected($event)" accept=".csv" />

  <div class="file-uploader__icon-wrapper">
    <app-icon class="file-uploader__icon" [icon]="IconName.UPLOAD" />
  </div>
  <div class="file-uploader__content">
    <p class="file-uploader__instruction">
      {{ 'inventory.uploadComponent.instruction' | translate }}
    </p>
    <div class="file-uploader__divider">
      <span class="file-uploader__divider-line"></span>
      <span class="file-uploader__divider-text">
        {{ 'inventory.uploadComponent.orDivider' | translate }}
      </span>
      <span class="file-uploader__divider-line"></span>
    </div>
    <button type="button" class="file-uploader__upload-btn" (click)="openFilePicker()">
      {{ 'inventory.uploadComponent.uploadButton' | translate }}
    </button>
  </div>
  <p class="file-uploader__hint">
    {{ 'inventory.uploadComponent.hint' | translate }}
  </p>
</div>

@if (isSubmitting()) {
  <span class="file-uploader__progress-wrapper">
    {{ 'inventory.uploadComponent.uploading' | translate }}
    <mat-progress-bar class="file-uploader__progress" mode="indeterminate" />
  </span>
} @else if (selectedFile()) {
  <div
    class="file-uploader__file-block"
    [class.file-uploader__file-block--invalid]="errorTextKey()"
  >
    <app-icon
      class="file-uploader__file-icon"
      [icon]="errorTextKey() ? IconName.FILE_INVALID_STATE : IconName.FILE"
    />
    <span>
      {{ selectedFile()!.name }}
    </span>
    <button class="file-uploader__unselect-btn" (click)="unselectFile()">
      <app-icon class="file-uploader__file-cross-icon" [icon]="IconName.SECONDARY_CROSS" />
    </button>
  </div>

  @if (errorTextKey()) {
    <p class="file-uploader__file-error-text">
      {{ errorTextKey() | translate }}
    </p>
  }
}

<div class="uploader-actions">
  <button
    type="button"
    class="uploader-actions__submit-btn"
    [disabled]="isSubmitting() || !selectedFile() || errorTextKey()"
    (click)="submitFile()"
  >
    {{ 'inventory.uploadComponent.submitButton' | translate }}
  </button>
</div>
